import { Locale } from 'modules/i18n';

export const endpointModalTranslation = {
  [Locale.en]: {
    copyEndpoint: 'Copy endpoint',
  },
};
